import React from "react"
import { CartItem } from "./CartItem"
import { sumBy, map, partition } from "lodash-es"
import { formatDate } from "../../services/Utils"

import { asCurrency } from "../../services/Utils"

export class Cart extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false
    }
  }

  toggle() {
    this.setState({
      visible: !this.state.visible
    })
  }

  seeOrder() {
    let path;
    if (this.props.seller_browsing) {
      path = "/admin/sales_orders/" + this.props.buyer_order.id + "/edit"
    } else {
      path = "/admin/purchase_orders/" + this.props.buyer_order.id + "/checkout"
    }
    window.location = path
  }

  removeItem(order_item_id) {
    if (confirm("Are you sure you want to remove this product from your cart?")) {
      this.props.removeOrderItem(order_item_id)
    }
  }

  updateOrderItemQuantity(buyer_order_item_id, quantity) {
    this.props.updateOrderItemQuantity(buyer_order_item_id, quantity)
  }

  renderCurrentItems(current_items) {
    const all_items = this.props.buyer_order.buyer_order_items
    if (all_items.length == 0) {
      return (
        <div className="mt-4 text-center">
          <span>No items in this order</span>
        </div>
      )
    }
    const currentTotal = sumBy(current_items, (x) => { return Number(x.subtotal) } )
    let currentItemsTitle
    let totalTitle
    if ( this.props.buyer_order.requested_on ) {
      const formattedDate = formatDate(this.props.buyer_order.requested_on)
      currentItemsTitle = `Order Items for ${ formattedDate }`
      totalTitle = `${ formattedDate} Total`
    } else {
      currentItemsTitle = 'Order Items'
      totalTitle = 'Total'
    }

    return (
        <div className="mt-4">
          <div className='px-2 pt-3 bg-light border-top'>
            <span className='h5 font-weight-bold'>{ currentItemsTitle }</span>
          </div>
          { this.renderItemList(current_items) }
          <div className='px-2 text-right border-top py-2'>
            <div className='h6 font-weight-bold'>{ `${ totalTitle }: ` }<span className='tabular-nums'>{ asCurrency(currentTotal) }</span></div>
          </div>
        </div>
    )

  }

  renderFutureItems(future_items) {
    if (future_items.length == 0) { return }

    const futureTotal = sumBy(future_items, (x) => { return Number(x.subtotal) } )

    return (
        <div className="mt-4">
          <div className='px-2 pt-3 bg-light border-top'>
            <span className='h5 font-weight-bold '>Future Items</span>
          </div>
          { this.renderItemList(future_items) }
          <div className='px-2 text-right border-top py-2'>
            <div className='h6 font-weight-bold'>Future Total: <span className='tabular-nums'>{ asCurrency(futureTotal) }</span></div>
          </div>
        </div>

    )
  }

  renderItemList(items) {
    return map(items, (buyer_order_item) => {
      return (
        <CartItem
          key={buyer_order_item.id}
          buyer_order_item={buyer_order_item}
          remove={this.removeItem.bind(this)}
          showProducer={this.props.showProducer}
          editQuantity={this.updateOrderItemQuantity.bind(this)}
        />
      )
    })
  }


  render() {
    if (!this.props.buyer_order ) { return <div></div> }


    const buyer_order = this.props.buyer_order
    const buyer_order_items = this.props.buyer_order.buyer_order_items
    const [current_items, future_items] = partition(buyer_order_items, (x) => { return !x.backorder })

    const orderTotal = sumBy(current_items, (x) => { return Number(x.subtotal) } )
    const itemCount = sumBy(this.props.buyer_order.buyer_order_items, (item) => { return Number(item.quantity) } )

    const body = (
      <div className="popout-shopping-cart-container text-left">
        <div className="p-3 popout-shopping-cart-header">
          <div className='d-flex justify-content-between'>
            <div>
              <span className='h5 font-weight-bold'>
                {buyer_order.name || "Order #" + buyer_order.id}
              </span>
            </div>
            <div className="float-right">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={this.toggle.bind(this)}
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-between mt-2">
            <div>
              <button
                className="btn btn-success"
                onClick={this.seeOrder.bind(this)}
              >
                <span className="fa fa-shopping-cart mr-1"></span>
                Checkout
              </button>
            </div>
            <div className="align-self-center">

              <span className='h5 font-weight-bold'>Total: <span className='tabular-nums'>{ asCurrency(orderTotal) }</span></span>
            </div>
          </div>
        </div>
        <div className="popout-shopping-cart-products">
          { this.renderCurrentItems(current_items) }
          { this.renderFutureItems(future_items) }
        </div>
      </div>
    )

    return (
      <div className='ml-2'>
        <button
          id="shopping-cart-toggle"
          className="drop-shadow-hover btn btn-success"
          onClick={this.toggle.bind(this)}
        >
          <i className="fa fa-shopping-cart" aria-hidden="true" />
          <div>{ itemCount }</div>
        </button>
        { this.state.visible ? body : null }
      </div>
    )
  }
}
